
<template>
  <div>
    <van-nav-bar
      title="入馆预约"
      fixed
      placeholder
      left-text="返回"
      right-text="首页"
      left-arrow
      @click-left="goBack"
      @click-right="goHome"
    />
    <van-notice-bar
      left-icon="volume-o"
      wrapable
      :scrollable="false"
      text="向左滑动可取消预约"
    />
    <div class="mt-1">
      <div class="mt-1 max-h-64 mb-2 overflow-y-auto overscroll-contain">
        <van-pull-refresh
          v-model="refreshing"
          success-text="加载成功"
          @refresh="onRefresh"
        >
          <van-swipe-cell
            v-for="entranceBooking in myEntranceBookings"
            :key="entranceBooking.id"
          >
            <van-cell
              :title="entranceBooking.activityinfo.title"
              center
              size="large"
              :label="`时间：${entranceBooking.finalTime.slice(
                5,
                19
              )}至${entranceBooking.activityinfo.endTime.date.slice(5, 19)}`"
            >
              <template #default>
                <van-tag plain type="success" v-if="entranceBooking.signInTime && entranceBooking.signInTime.date.slice(0,4)>'2010'"
                  ><span class="whitespace-nowrap">已签到</span></van-tag
                >
              </template>
            </van-cell>
            <template #right>
              <van-button
                class="mt-1.5"
                round
                type="danger"
                text="取消预约"
                @click="cancelBook(entranceBooking)"
              />
            </template>
          </van-swipe-cell>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import { toRefs, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { getMyEntrances, cancelEntrance } from "@/service/home";
import { Dialog } from "vant";
import qs from "qs";
import Cookies from "js-cookie";
export default {
  name: "myEntranceBookings",
  components: {},
  setup() {
    const user = JSON.parse(Cookies.get("user"));
    const router = useRouter();
    const state = reactive({
      myEntranceBookings: [],
      refreshing: false,
      loading: true,
    });
    const goBack = () => router.go(-1);
    const goHome = () => router.push("/index");
    const onRefresh = async () => {
      loadBookings();
    };
    onMounted(() => {
      loadBookings();
    });
    const loadBookings = async () => {
      const { data } = await getMyEntrances({
        access_token: user.access_token,
        userid: user.userid,
      });
      state.myEntranceBookings = data.map(item=>{
        if (item.examTime.date<item.activityinfo.beginTime.date) {
          item.finalTime = item.activityinfo.beginTime.date;
        } else {
          item.finalTime = item.examTime.date;
        }
        return item;
      });
      state.refreshing = false;

      state.loading = false;
    };
    const cancelBook = async (booking) => {
      try {
        const {
          data: { list },
          msg,
        } = await cancelEntrance(
          booking.activity,
          qs.stringify({
            userid: user.userid,
          })
        );
        if (list) {
          Dialog.alert({
            title: "提示",
            message: "你已成功取消预约了",
          }).then(() => {
            loadBookings();
          });
        } else {
          Dialog.alert({
            title: "提示",
            message: msg,
          }).then(() => {});
        }
      } catch (error) {
        Dialog.alert({
          title: "提示",
          message: "取消失败",
        }).then(() => {});
      }
    };
    return {
      goBack,
      goHome,
      onRefresh,
      cancelBook,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" >
@import "../common/style/base";
.selected {
  background-color: #49cfd4;
  color: white;
}
.van-cell__title {
  flex: 1 1 auto;
}
.van-cell__value {
  flex: 1 1 auto;
}
</style>
